module.exports = __webpack_public_path__ + "static/media/15.8b1b7a43.jpg";